import { css } from '@emotion/react';

export const separator = css`
  font-size: var(--font-size-1);
  line-height: var(--line-height-1);
  color: var(--gray-9);
`;
